import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Button from 'Douleutaras/components/Button';

import DefaultFullLayout from '../DefaultFullLayout';

import './NotFound.scss';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          404
        </title>
      </Helmet>
      <div styleName="error-page-intro-inner">
        <article styleName="error-page-info">
          <div styleName="error-page-preview">
            <img
              src={`${process.env.ASSETS_CDN_PATH}/douleutaras/img/vendor/v1/icon-error-404.svg`}
              alt="" />
          </div>
          <h1 styleName="error-page-title">
            <span>{t('Oops!')}</span> {t('Something went wrong.')}
          </h1>
          <div styleName="error-page-action">
            <a href="/" className="default-btn default-btn--bold default-btn--yellow">

            </a>
            <Button href="/" type="Primary">
              {t('Go to homepage')}
            </Button>
          </div>
        </article>
      </div>
    </>
  );
};

export const NotFoundWrapped = () => {
  return (
    <DefaultFullLayout>
      <NotFound />
    </DefaultFullLayout>
  );
};

export default NotFound;
